__webpack_require__.p = "https://ninpath.work/";